import { ActionList } from '../../../../../common/models/action-list.model';
import { DepartmentStateTab } from '../department-model';

export const ACTIONS_INDEXES = {
  VIEW: 0,
  EDIT: 1,
  ACTIVATE: 2,
  DEACTIVATE: 3,
  DELETE: 4,
};

export const ACTIONS_MENU_ITEMS: ActionList[] = [
  {
    key: 'view',
    hasIcon: true,
    label: 'view_details_action_item',
    hasDivider: false,
    labelCustomStyle: '',
  },
  {
    key: 'edit',
    hasIcon: true,
    label: 'edit_action_item',
    hasDivider: true,
    labelCustomStyle: '',
  },
  {
    key: 'activate',
    hasIcon: true,
    label: 'activate_action_item',
  },
  {
    key: 'deactivate',
    hasIcon: true,
    label: 'deactivate_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
  {
    key: 'delete',
    hasIcon: true,
    label: 'delete_action_item',
    labelCustomStyle: 'text-destructive-500!',
  },
];

export const DEPARTMENT_STATE_TABS: ReadonlyArray<{
  key: DepartmentStateTab;
  label: string;
}> = [
  { key: 'all', label: 'table_filter_tab_all_label' },
  { key: 'active', label: 'table_filter_tab_active_label' },
  { key: 'inactive', label: 'table_filter_tab_inactive_label' },
];

export const DEPARTMENT_TREE_PAGE_SIZES = [25, 50, 100, 150];

export const DEPARTMENT_TREE_DEFAULT_PAGE_SIZE = 50;
